// extracted by mini-css-extract-plugin
module.exports = {"compatibility":"Technologies-styles-module--compatibility--2eJuJ"};